
const AuthenticatedContent = () => {
  return (
    <div className="info_wnd">
          <div>
            <b>Зеркала:</b>{" "}
            <a href="https://sergey-mavrodi.ms/">
              sergey-mavrodi.ms
            </a>{" "}
            и{" "}
            <a href="https://mavrodi-mmm-2011.com/">
              mavrodi-mmm-2011.com
            </a>
          </div>
          <b>ПОМНИТЕ!</b> Проблемы с сайтом или с ЛК никак не влияют на работу
          самой Системы. <br/> Пообщайтесь с Администратором и успокойтесь. Это всего лишь обычные технические сбои и не более
          того. Всё наладится! :-))
        </div>
  );
};

export default AuthenticatedContent;
